import { APIConfig } from '../../types/definitions'
import { createGrpcAuthenticator } from 'infra/grpc-authenticator'
import { enableDevTools } from '../../utils/grpc-util'
import { memoize } from 'lodash'
import { JobRatingServicePromiseClient } from '@taxfyle/api-internal/internal/job_rating_grpc_web_pb'
import {
  GetJobRatingStatusRequest,
  SubmitProRatingRequest,
} from '@taxfyle/api-internal/internal/job_rating_pb'

/**
 * Creates a job ratings dotnet client that is memoized.
 */
const createJobRatingsGrpcClient = memoize(function createJobGrpcClient(
  baseUrl: string,
) {
  const client = new JobRatingServicePromiseClient(baseUrl)
  enableDevTools(client)
  return client
})
export const createJobRatingAPI = (config: APIConfig) =>
  new JobRatingAPI(config)

export class JobRatingAPI {
  private readonly jobStatsGrpcClient = createJobRatingsGrpcClient(
    this.workDotnetConfig.baseURL,
  )

  private readonly grpcAuthenticator = createGrpcAuthenticator(
    this.workDotnetConfig,
  )

  constructor(private workDotnetConfig: APIConfig) {}

  getJobRatingStatus = async (request: GetJobRatingStatusRequest) =>
    this.jobStatsGrpcClient.getJobRatingStatus(
      request,
      await this.grpcAuthenticator.getMeta(),
    )

  submitProRating = async (request: SubmitProRatingRequest) =>
    this.jobStatsGrpcClient.submitProRating(
      request,
      await this.grpcAuthenticator.getMeta(),
    )
}
